import { FindElById } from './script.js'; 
import { sm } from './modalDialogBox.js'; 
/*
1) Useful functions.
3) Email: validation and send from modal dialog box.
4) Availability: highlighting, synching and validation.
5) Form Level validation
6) Fieldset level validation
*/

//1) Useful functions.
var intSubmission = 0;
var curFocus = '';
var postcodeModal = false;
var pendingEvent;
var surchargePercentCreditCard = 2;
var surchargePercentDebitCard = 0;

function firstSubmission() {
    if (intSubmission == 0) {
        intSubmission++;
        return true;
    }
    return false;
}
function selectAll(id) {
    document.getElementById(id).focus();
    if (id != curFocus) {
        document.getElementById(id).select();
    }
    curFocus = id;
}

function popDependantDdl(strH1Index, ddlH2Container) {
    var strH2ArrayItems;
    var strH2ArrayValues;
    ddlH2Container.options.length = 0;
    if (strH1Index != '0') {
        strH2ArrayItems = globalThis['arrH2Items_' + strH1Index] || [];
        strH2ArrayValues = globalThis['arrH2Values_' + strH1Index] || [];
        for (var i = 0; i < strH2ArrayItems.length; i++) {
            ddlH2Container.options[ddlH2Container.options.length] = new Option(strH2ArrayItems[i], strH2ArrayValues[i]);
        }
    }
    else {
        ddlH2Container.options[ddlH2Container.options.length] = new Option('                                                                            ', '0');
    }
}
function showWait() {
    document.getElementById('divHide').style.display = 'block';
    setTimeout('document.images["pbar"].src = "/media/progbar.gif"', 500);
}

function popInfo2(url, width, height) {
    sealWin2 = window.open(url, "win", 'toolbar=0,location=0,directories=0,status=1,menubar=0,scrollbars=1,resizable=1,width=' + width + ',height=' + height);
    self.name = "mainWin";
    sealWin2.focus();
    sealWin2.resizeTo(width, height);
}

function setCard(strCType) {
    var ddl = FindElById('ddlCardType');
    var len = ddl.length - 1;
    var selIndex = -1;
    var i;
    for (i = 0; i <= len; i++) {
        if (ddl.options[i].value == strCType) {
            selIndex = i;
        }
    }
    ddl.selectedIndex = selIndex;
    cardTypeChanged();
}
// make function available on the global scope to be used in onclick events
window.setCard = setCard;

function val() {
    if (FindElById('ddlCardType').selectedIndex == 0) {
        alert('You must select your Card Type.');
        FindElById('ddlCardType').focus();
        return false;
    }
    if (FindElById('txtCardNo').value == '') {
        alert('You must complete your Card Number.');
        FindElById('txtCardNo').focus();
        return false;
    }
    if (FindElById('ddlExpMonth').selectedIndex == 0 || FindElById('ddlExpYear').selectedIndex == 0) {
        alert('You must complete the Card Expiry Date.');
        FindElById('ddlExpMonth').focus();
        return false;
    }
    if ((FindElById('ddlFromMonth').selectedIndex == 0 || FindElById('ddlFromYear').selectedIndex == 0) && (FindElById('txtIssueNo').value == '')) {
        alert('You must complete either the Issue Number or Card Valid From Date.');
        FindElById('ddlExpMonth').focus();
        return false;
    }
    if (FindElById('txtSecurityCode').value == '') {
        alert('You must complete your Security Code.');
        FindElById('txtSecurityCode').focus();
        return false;
    }
    return true;
}
//5) Form Level validation  
function validateBroReq() {
    if (validatePerson() != true) {
        return false;
    }
    if (validateContacts(1) != true) {
        return false;
    }
    return true;
}
function validateResStage1() {
    if (validatePerson() != true) {
        return false;
    }
    if ($('PersonDetails1_OtherCon_txtHomeTel')) {
        if (validateAdditionalContacts(1) != true) {
            return false;
        }
    } else {
        if (validateContacts(2) != true) {
            return false;
        }
    }
    return true;
}
function validateOtherContactsPerson() {
    if (FindElById("pnlOtherContactInfo") === null) {
        // Stage 2 contact details aren't required
        // either provided in Stage 1 or ten obj already set up
        return true;
    }

    if (FindElById("pnlOtherContactInfoPartyDetails") === null) {
        // Stage 2 contact details aren't required
        // either provided in Stage 1 or ten obj already set up
        //
        return true;
    }

    if (FindElById('OtherCon_txtTitle').value === "") {
        alert("Please enter your title");
        FindElById('OtherCon_txtTitle').focus();
        return false;
    }
    if (FindElById('OtherCon_txtFirstName').value === "") {
        alert("Please enter your first name");
        FindElById('OtherCon_txtFirstName').focus();
        return false;
    }
    if (FindElById('OtherCon_txtSurname').value === "") {
        alert("Please enter your lastname");
        FindElById('OtherCon_txtSurname').focus();
        return false;
    }
    if (FindElById('OtherCon_txtMobile').value === "" && FindElById('OtherCon_txtHomeTel').value === "" && FindElById('OtherCon_txtWorkTel').value === "") {
        alert("Please eneter at least one phone number");
        FindElById('OtherCon_txtMobile').focus();
        return false;
    }

    return true;
}

function validateResStage2() {
    //check make sure other contacts filled in
    if (validateOtherContactsPerson() !== true) {
        return false;
    } else {
        /*Show the wait screen whilst the reservation request is processed server side.*/
        sm('procBox', 450, 275);
        setTimeout('document.images["pbar"].src = "/images/progresscircle.gif"', 300);
        return true;
    }
}
//make global so that the function can be picked up globaly
window.validateResStage2 = validateResStage2;
function validateBookStage1() {
    if (validatePerson() != true) {
        return false;
    }
    if (atleastoneContacts() != true) {
        alert("Please provide at least one email address or telephone number on which we may contact you.");
        return false;
    }
    if (allPartyMembers() != true) {
        return false;
    }
    return true;
}
function validateBookStage2() {
    if (validateCard() != true) {
        return false;
    }
    if (document.forms[0].CtlDeclaration1_chkBookCond.checked == false) {
        alert("Please note that you must check the booking condtions\ndeclaration box before we can accept an option");
        return false;
    }
    return true;
}
function validateBalance() {
    if (validateCard() != true) {
        return false;
    }
    return true;
}
function validateFeedback() {
    if (document.forms[0].CtlFeedback1_txtName.value.length == 0) {
        alert("Please complete your name");
        return false;
    }
    if (document.forms[0].CtlFeedback1_txtEmail.value.length == 0) {
        alert("Please complete your email address");
        return false;
    }
}
function validateSendMail() {
    if (document.forms[0].txtFromAddr.value.length == 0) {
        alert('Please complete your email address.');
        return false;
    }
    if (document.forms[0].txtToAddr.value.length == 0) {
        alert('Please complete the recipients email address.');
        return false;
    }
    if (validateEmail(document.forms[0].txtFromAddr.value, 'from') != true) {
        return false;
    }
    if (validateEmail(document.forms[0].txtToAddr.value, 'to') != true) {
        return false;
    }
    return true;
}
function validateAdvRes() {
    if (validatePerson() != true) {
        return false;
    }
    if (validateContacts(1) != true) {
        return false;
    }
    if (document.forms[0].lstFromDay.value == 0 || document.forms[0].lstFromMonth.value == 0) {
        alert("Please complete your intended arrival date.");
        return false;
    }
    if (document.forms[0].lsttoDay.value == 0 || document.forms[0].lsttoMonth.value == 0) {
        alert("Please complete you intended departure date.");
        return false;
    }
    return true;
}
// make global so that the function can be picked up globaly
window.validateAdvRes = validateAdvRes;
function validateLogin() {
    if (document.forms[0].Login1_txtTRN.value == "") {
        alert("Please enter your personal reference number");
        document.forms[0].Login1_txtTRN.focus();
        return false;
    }
    if (document.forms[0].Login1_txtBRN.value == "") {
        alert("Please enter your booking reference number");
        document.forms[0].Login1_txtBRN.focus();
        return false;
    }
    if (isInteger(document.forms[0].Login1_txtTRN.value) != true) {
        alert("Your personal reference number must be numeric.");
        document.forms[0].Login1_txtTRN.focus();
        return false;
    }
    if (isInteger(document.forms[0].Login1_txtBRN.value) != true) {
        alert("Your booking reference number must be numeric.");
        document.forms[0].Login1_txtBRN.focus();
        return false;
    }
    return true;
}
//6) Fieldset level Validation
function allPartyMembers() {
    for (var i = 0; i <= 16; i++) {
        if (document.getElementById('PartyMembers1_txtNameA' + i)) {
            if (document.getElementById('PartyMembers1_txtNameA' + i).value == '') {
                alert("Please complete the details of the other members in your party, you can enter 'TBC' if you do not yet know who is accompanying you.");
                return false;
            }
        }
        if (document.getElementById('PartyMembers1_txtNameB' + i)) {
            if (document.getElementById('PartyMembers1_txtNameB' + i).value == '') {
                alert("Please provide the name of all babies in your party, you can enter 'TBC' if you are not yet sure!");
                return false;
            } else {
                if (document.getElementById('PartyMembers1_txtAgeB' + i).value == '') {
                    alert("Please provide the age (in months) of all babies in your party, you can enter 'TBC' if you are not yet sure!");
                    return false;
                }
            }
        }
    }
    return true;
}
function validateCard() {
    if (FindElById('ddlCardType').value == "Please Select") {
        alert("Please select your card type");
        return false;
    }
    if (FindElById('txtCardNo').value == "") {
        alert("Pleae enter your card number");
        return false;
    }
    if (FindElById('ddlExpMonth').value == "--" || FindElById('ddlExpYear').value == "--") {
        alert("Please complete the expiry date");
        return false;
    }
    if (FindElById('ddlFromMonth').value == "--" && FindElById('ddlFromYear').value != "--") {
        alert("Valid From Date incorrectly completed");
        return false;
    }
    if (FindElById('ddlFromMonth').value != "--" && FindElById('ddlFromYear').value == "--") {
        alert("Valid From Date incorrectly completed");
        return false;
    }
    if (FindElById('ddlFromMonth').value == "--" && FindElById('ddlFromYear').value == "--" && FindElById('txtIssueNo').value == "") {
        alert("Please provide either the valid from date or an issue number");
        return false;
    }
    return true;
}
function validatePerson() {
    if (FindElById('txtTitle').value == "") {
        alert("Please enter your title");
        FindElById('txtTitle').focus();
        return false;
    }
    if (document.forms[0].PersonDetails1_txtInitials.value == "") {
        alert("Please enter your initials");
        FindElById('txtInitials').focus();
        return false;
    }
    if (FindElById('txtSurname').value == "") {
        alert("Please enter your surname");
        FindElById('txtSurname').focus();
        return false;
    }
    if (FindElById('txtAdd1').value == "") {
        alert("Please enter the first line of your address");
        document.forms[0].PersonDetails1_txtAdd1.focus();
        return false;
    }
    if (FindElById('txtPostCode').value == "") {
        alert("Please enter your Postcode or ZIP");
        document.forms[0].PersonDetails1_txtPostCode.focus();
        return false;
    }
    return true;
}
function validateContacts(numRequired) {
    var numCompleted = 0;
    numCompleted += ((FindElById('txtEMail').value == "") ? 0 : 1)
    numCompleted += ((FindElById('txtHomeTel').value == "") ? 0 : 1)
    numCompleted += ((FindElById('txtWorkTel').value == "") ? 0 : 1)
    numCompleted += ((FindElById('txtMobile').value == "") ? 0 : 1)
    if (numCompleted < numRequired) {
        alert("Please provide at least " + numRequired + " way" + ((numRequired > 1) ? "s" : "") + " in which we may contact you.");
        return false;
    }
    if (validateEmail(FindElById('txtEMail').value) == false) {
        selectAll('PersonDetails1_txtEMail');
        return false
    }
    return true;
}
function validateAdditionalContacts(numRequired) {
    var numCompleted = 0;
    numCompleted += (($('PersonDetails1_OtherCon_txtHomeTel').value == "") ? 0 : 1);
    numCompleted += (($('PersonDetails1_OtherCon_txtWorkTel').value == "") ? 0 : 1);
    numCompleted += (($('PersonDetails1_OtherCon_txtMobile').value == "") ? 0 : 1);
    if (numCompleted < numRequired) {
        alert("Please provide at least " + numRequired + " telephone number" + ((numRequired > 1) ? "s" : "") + " we can use to contact you.");
        return false;
    }
    return true;
}
function highlightBedroom(bedroomNumber, over) {
    if ($('bedroomDescription')) {
        if ($('bedroomDesc' + bedroomNumber)) {
            var bedroomDesc = $('bedroomDesc' + bedroomNumber);
            if (over) {
                bedroomDesc.initialClassName = bedroomDesc.className;
                bedroomDesc.className = bedroomDesc.className + ' highlightBedroom';
            } else {
                bedroomDesc.className = bedroomDesc.initialClassName;
            }
        }
    }
}
// Returns true if s contains Html tags.
function stringContainsTags(s) {
    if (!s) { s = '' };
    var regExp = new RegExp("<|>|;||/?|[|/^|]|/+|$", "g")
    var newS = s.replace(regExp, "");
    if (newS != s) {
        return true;
    } else {
        return false;
    }
}

function CheckNominations(sender, args) {
    if ($('#CustomerMobileCustomValidator').val() === ""
        && $('#CustomerWorkNumberCustomValidator').val() === ""
        && $('#CustomerHomeTelCustomValidator').val() === ""){
        args.IsValid = false;
    }
   else {
        args.IsValid = true;

    }

}



function cardTypeChanged() {
    if (FindElById('ddlCardType')) {
        var strCType = FindElById('ddlCardType').value;
    }
    if (FindElById('maestroOnly')) {
        var validFromInputs = FindElById('maestroOnly').querySelectorAll("select");
        if (strCType === 'MO') {
            FindElById('maestroOnly').style.display = 'block';
            var i;
            for (i = 0; i < validFromInputs.length; i++) {
                validFromInputs[i].removeAttribute("disabled");
            }
        } else {
            FindElById('maestroOnly').style.display = 'none';
            for (i = 0; i < validFromInputs.length; i++) {
                validFromInputs[i].setAttribute("disabled", "disabled");
            }
        }
    }
}
window.cardTypeChanged = cardTypeChanged;


var altCardHolder = document.querySelector('.rdoCardHolder');
if (altCardHolder !== null) {
    var toggleAlternativeCardHolder = function () {
        var selectedOption = document.querySelector('input[name="' + altCardHolder.name + '"]:checked');
        var value = parseInt(selectedOption.value, 10);
        // show/hide the alternative address block
        document.querySelector('.alternative-cardholder').style.display = value === 1 ? 'block' : 'none';
        
    };

    // immediately set the display state;
    toggleAlternativeCardHolder();

    // set the display state when the option is changed.
    var options = document.querySelectorAll('input[name="' + altCardHolder.name + '"]');
    for (i = 0; i < options.length; i++) {
        options[i].addEventListener('click', toggleAlternativeCardHolder);
    }
}

var toggleCountryConditionalParams = function (e) {
    var ddl = e.target;
    var postcodeRequired = ddl.querySelector('option[value="' + ddl.value + '"]').getAttribute('data-postcode') === 'true';
    var wrapper = ddl.parentNode.parentNode;
    var postcodeInput = wrapper.querySelector('.txtPostCode');
    var postcodeLabel = wrapper.querySelector('.lblPostcode');
    var zipcodeLabel = wrapper.querySelector('.lblZipcode');
    var postcodeRequiredSpan = wrapper.querySelector('.lblPostcode .required');
    var stateDiv = wrapper.querySelector('.pdUSState');
    var countyDiv = wrapper.querySelector('.pdCounty');
    var findAddress = wrapper.querySelector('.findAddress');

    if (postcodeRequired) {
        postcodeInput.setAttribute('required', 'required');
        postcodeRequiredSpan.style.display = '';
    } else {
        postcodeInput.removeAttribute('required');
        postcodeRequiredSpan.style.display = 'none';
    }
    stateDiv.style.display = ddl.value === 'US' ? 'block' : 'none';
    countyDiv.style.display = ddl.value === 'US' ? 'none' : 'block';
    zipcodeLabel.style.display = ddl.value === 'US' ? 'block' : 'none';
    postcodeLabel.style.display = ddl.value === 'US' ? 'none' : 'block';
    if (findAddress !== null) {
        findAddress.style.display = ddl.value === 'GB' ? 'block' : 'none';
    }
}

var countryDDLs = document.querySelectorAll('.ddlCountry');
for (var i = 0; i < countryDDLs.length; i++) {
    var ddl = countryDDLs[i];
    ddl.addEventListener('change', toggleCountryConditionalParams);
    toggleCountryConditionalParams({ target: ddl });
}

if (document.getElementsByClassName('sagev4-browserparams').length > 0) {
    // populate sagepay browser info
    FindElById('hdnBrowserJavascriptEnabled').value = '1';
    FindElById('hdnBrowserJavaEnabled').value = navigator.javaEnabled() ? '1' : '0';
    // need to add a conditional on the colorDepth as 10 bit displays might return "30"
    // which is not a valid value for 3DSv2
    FindElById('hdnBrowserColorDepth').value = (function () {
        switch (screen.colorDepth) {
            case 30:
                return 24;
            default:
                return screen.colorDepth;
        }
    })();
    FindElById('hdnBrowserScreenHeight').value = screen.height;
    FindElById('hdnBrowserScreenWidth').value = screen.width;
    FindElById('hdnBrowserTimezoneOffset').value = (new Date()).getTimezoneOffset();
    FindElById('hdnBrowserLanguage').value = navigator.language;

    const iframeContentWidth = parseInt(document.querySelector('.sagev4-browserparams').clientWidth, 10);
    let challengeWindowSize = '01';
    if (iframeContentWidth >= 390) { challengeWindowSize = '02' };
    if (iframeContentWidth >= 500) { challengeWindowSize = '03' };
    if (iframeContentWidth >= 600) { challengeWindowSize = '04' };
    FindElById('hdnChallengeWindowSize').value = challengeWindowSize;
}